import * as React from "react";
const SvgChevronDown20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 6,
        fill: "black",
        viewBox: "0 0 10 6"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5 5.562 9.635 0H.365L5 5.562Z",
      clipRule: "evenodd"
    })
  );
export default SvgChevronDown20Px;
